import { useState } from 'react';
import { useLocation } from 'react-router';
import { post } from '../lib/api';
import { useStore } from '../store';
import { Sheet } from './Sheet';

/** The beta feedback button: a note (and optional screenshot) → GitHub issue via the server. */
export function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [shot, setShot] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { notify } = useStore();
  const loc = useLocation();
  const grab = async () => {
    try {
      const { default: toPng } = await import('../lib/screenshot');
      setShot(await toPng());
    } catch { notify("Couldn't capture the screen — describe it instead", { kind: 'error' }); }
  };
  const send = async () => {
    setBusy(true);
    try { const r = await post<{ issue: string | null }>('/api/feedback', { note, page: loc.pathname, screenshot: shot ?? undefined }); notify(r.issue ? 'Thanks! Logged as a GitHub issue.' : 'Thanks! Feedback sent.', { kind: 'success' }); setOpen(false); setNote(''); setShot(null); }
    catch (e) { notify((e as Error).message, { kind: 'error' }); } finally { setBusy(false); }
  };
  return (
    <>
      <button className="fab" onClick={() => setOpen(true)} aria-label="Send feedback or report a bug">🐛</button>
      <Sheet open={open} onClose={() => setOpen(false)} title="Found a bug? Got an idea?">
        <p className="muted">Tell us what happened, what you expected, and what you were doing. It goes straight to the dev board.</p>
        <textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Tamed a level 6 with 3+3 but it said 'not enough'" rows={4} maxLength={2000} />
        <div className="row" style={{ marginTop: 8 }}>
          <button className="btn sm" onClick={grab}>{shot ? '📸 Screenshot attached' : '📸 Attach screenshot'}</button>
          {shot && <button className="btn xs ghost" onClick={() => setShot(null)}>remove</button>}
        </div>
        {shot && <img src={shot} alt="Screenshot preview" style={{ maxWidth: '100%', marginTop: 8, borderRadius: 8, border: '2px solid var(--ink)' }} />}
        <div className="row" style={{ marginTop: 12 }}><button className="btn primary" disabled={busy || note.trim().length < 3} onClick={send}>Send</button><button className="btn" onClick={() => setOpen(false)}>Cancel</button></div>
      </Sheet>
    </>
  );
}
